<template>
  <section class="e-doc" aria-labelledby="estrena2-doc-title">
    <img class="e-doc__image" :src="image" alt="Mujer sonriendo con los brazos cruzados">

    <div class="e-doc__content">
      <span class="e-doc__tag">Documentación</span>

      <div class="e-doc__text">
        <h2 id="estrena2-doc-title" class="e-doc__title">Lo que necesitarás para tu proceso</h2>
        <p class="wd-body">
          Reúne esta documentación para que <br class="br-m">tu proceso avance <br class="br-d">sin contratiempos.
        </p>
      </div>

      <ul class="e-doc__items">
        <li v-for="item in items" :key="item.text" class="e-doc__item">
          <span class="e-doc__icon" :class="{ 'e-doc__icon--small': item.small }">
            <img :src="item.icon" alt="" aria-hidden="true">
          </span>
          <span class="wd-body" v-html="item.text" />
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import image from '../../../assets/estrena2-figma/documentacion.jpg'
import incomeIcon from '../../../assets/estrena2-figma/doc-income.svg'
import idIcon from '../../../assets/estrena2-figma/doc-id.svg'
import propertyIcon from '../../../assets/estrena2-figma/doc-property.svg'
import paymentsIcon from '../../../assets/estrena2-figma/doc-payments.svg'

const items = [
  { icon: incomeIcon, text: 'Comprobantes de ingresos' },
  { icon: idIcon, text: 'Identificación oficial', small: true },
  { icon: propertyIcon, text: 'Documentación relacionada <br>con el inmueble' },
  { icon: paymentsIcon, text: 'Información de los pagos realizados al vendedor' }
]
</script>

<style scoped>
.e-doc { display: flex; align-items: stretch; gap: var(--ds-space-5); }

.e-doc__image {
  flex: 0 0 370px;
  width: 370px;
  min-width: 0;
  object-fit: cover;
  border-radius: 24px;
}

.e-doc__content {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--ds-space-6);
  min-width: 0;
}

.e-doc__tag {
  display: inline-flex;
  align-items: center;
  padding: var(--ds-space-3);
  border-radius: 9999px;
  background: var(--ds-tag-orange-fill);
  color: var(--ds-tag-orange-text);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.e-doc__text { display: flex; flex-direction: column; gap: var(--ds-space-3); width: 100%; }
.e-doc__title {
  margin: 0;
  color: var(--ds-purple-900);
  font-family: var(--ds-font-family-bebas);
  font-size: 32px;
  font-weight: 700;
  line-height: normal;
}

.e-doc__items { display: flex; flex-direction: column; gap: var(--ds-space-6); width: 100%; margin: 0; padding: 0; list-style: none; }
.e-doc__item { display: flex; align-items: center; gap: var(--ds-space-3); min-height: 40px; }
.e-doc__icon { display: flex; flex: 0 0 40px; align-items: center; justify-content: center; width: 40px; height: 40px; }
.e-doc__icon img { display: block; width: 40px; height: 40px; }
.e-doc__icon--small img { width: 20px; height: 16px; }

@media (max-width: 1024px) {
  .e-doc__image { flex-basis: 340px; width: 340px; }
}

@media (max-width: 599px) {
  .e-doc { flex-direction: column; padding: var(--ds-space-5) 0; }
  .e-doc__image { flex: none; width: 100%; height: 310px; }
  .e-doc__content { flex: none; gap: var(--ds-space-5); width: 100%; }
}
</style>
